var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-h-65 tw-px-3 tw-py-1.5 tw-whitespace-nowrap tw-text-xs tw-rounded"},[_c('span',[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }